
import { useContext, useEffect, useState } from "react";
import AppTable from "../../components/shared-components/table/AppTable";
import { AddTicketsInput } from "./AddTickets";
import { useLazyQuery } from "@apollo/client";
import { GET_EVENTS_BY_HOME_AND_AWAY_TEAM_ID, GET_EVENTS_BY_HOME_TEAM_ID, GET_EVENTS_BY_OTHER_LEAGUES } from "./api/addTicketsQuery";
import { Button, CircularProgress, TextField, FormControlLabel, Checkbox, Box } from "@mui/material";
import addTicketStyles from "./AddTickets.module.css";
import styles from "../Settings/AppVersion.module.css";
import ToasterWithMessage from "../../components/shared-components/toaster";
import stylesUser from "../Users/Users.module.css";
import { globalContext } from "../../Provider/AppProvider";
import { isEventEligibleForAddTickets } from "../../constants/addTicketEventVisibility";
import { useMutation } from "@apollo/client";
import { config } from "../../config/config";

const PickEvents = ({
    setPage,
    ticketDetails,
    setTicketDetails,
    isFrom,
    page,
    search,
    setResetEvent,
    resetEvent
}: AddTicketsInput) => {
    const [events, setEvents] = useState<any>([]);
    const [selected, setSelected] = useState<number[]>([]);
    const [selectedEvents, setSelectedEvents] = useState<string[]>([]);
    const [checking, setChecking] = useState<boolean>(false);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [searchEventName, setSearchEventName] = useState('');
    const [showAllDates, setShowAllDates] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [columnTypes, setColumnTypes] = useState('e_date');
    const [sortType, setSortType] = useState('asc');
    const { error } = ToasterWithMessage();
    const { globalState, handleGlobalState } = useContext<any>(globalContext);

    const handleChangeRowsPerPage = (event: any) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setSelected([]);
        setCurrentPage(1);
    }

    const handlePageChange = (_event: any, newPage: number) => {
        setCurrentPage(newPage);
    }

    const handleSearchEventNameChange = (event: any) => {
        const searchValue = event.target.value;
        setSearchEventName(searchValue);
        setCurrentPage(1);
        setSelected([]);
    }

    const handleClearSearch = () => {
        setSearchEventName('');
        setCurrentPage(1);
        setSelected([]);
    }

    const handleShowAllDatesChange = (event: any) => {
        const isChecked = event.target.checked;
        setShowAllDates(isChecked);
        setCurrentPage(1);
    }

// REMOVED: GraphQL mutation declaration. Only use fetch-based function below.
    const filterEventsByDate = (eventsData: any) => {
        if (!eventsData || !eventsData.events) return eventsData;
        
        let filteredEvents = eventsData.events.filter((event: any) => isEventEligibleForAddTickets(event));
        let filteredAggregate = eventsData.events_aggregate;

        if (!showAllDates) {
            // Filter to only show events with valid dates (not TBD and not null)
            // Exclude events where: e_date is null/empty OR e_status contains "tbd"
            filteredEvents = filteredEvents.filter((event: any) => {
                const hasValidDate = event.e_date !== null && event.e_date !== undefined && event.e_date !== '';
                const isTBD = event.e_status?.toLowerCase().includes('tbd');
                const isValid = hasValidDate && !isTBD;
                return isValid;
            });
            filteredAggregate = {
                ...eventsData.events_aggregate,
                aggregate: {
                    ...eventsData.events_aggregate?.aggregate,
                    count: filteredEvents.length
                }
            };
        }

        filteredAggregate = {
            ...filteredAggregate,
            aggregate: {
                ...filteredAggregate?.aggregate,
                count: filteredEvents.length,
            },
        };

        return {
            ...eventsData,
            events: filteredEvents,
            events_aggregate: filteredAggregate
        };
    }

    const [getEventsForBulkList, { loading: bulkListLoading }] = useLazyQuery(GET_EVENTS_BY_HOME_TEAM_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(filterEventsByDate(data));
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const [getEventsForSingleList, { loading: singleListLoading }] = useLazyQuery(GET_EVENTS_BY_HOME_AND_AWAY_TEAM_ID, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(filterEventsByDate(data));
            if (globalState.eventUpdate.updateEvent) {
                const tempState = { ...globalState };
                tempState.eventUpdate.updateEvent = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    })

    const [getEventsForOtherLeagues, { loading: otherListLoading }] = useLazyQuery(GET_EVENTS_BY_OTHER_LEAGUES, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            setEvents(filterEventsByDate(data));
            if (globalState.eventUpdate.updateEvent) {
                const tempState = { ...globalState };
                tempState.eventUpdate.updateEvent = false
                handleGlobalState(tempState);
            }
        },
        onError: (err) => {
            console.log(err)
        }
    })
// REST API fetch call for bulk event status update


// REST API fetch call for bulk event status update
const bulkUpdateEventsStatus = async (
  eventIds: string[],
  isActive: boolean
 
) => {
     console.log(eventIds, isActive)
  const nodeApiBaseUrl = (process.env.REACT_APP_NODE_API_URL || config.node_api_url || '').replace(/\/+$/, '');
  const res = await fetch(
    `${nodeApiBaseUrl}/api/events/bulk-update-status`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        eventIds,
        isActive,
      }),
    }
  );

  if (!res.ok) {
    throw new Error("API Error");
  }

  const data = await res.json();
  console.log(data);
  return data;
};

const handleBulkStatusChange = async (isActive: boolean) => {
    const { error, success } = require('../../components/shared-components/toaster').default();
    if (!selectedEvents.length) {
        error("Please select at least one event");
        return;
    }
    try {
        const result = await bulkUpdateEventsStatus(selectedEvents, isActive);
        if (result.success) {
            success(`Successfully updated ${result.updated} events.`);
            // Optionally refresh your event list here
        } else {
            error("Update failed: " + (result.error || "Unknown error"));
        }
        setSelectedEvents([]);
    } catch (err) {
        error("Network or server error");
    }
};
    useEffect(() => {
        if (ticketDetails?.isBulkList) {
             if (ticketDetails?.leagueType?.toLowerCase() === "sports") {
            getEventsForBulkList({
                variables: {
                    homeTeamId: ticketDetails?.homeTeamId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    eventName: searchEventName ? `%${searchEventName}%` : '%',
                }
            })}
            else{
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: searchEventName ? `%${searchEventName}%` : `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                    }
                })
            }
        } else {
            if (ticketDetails?.leagueType?.toLowerCase() === "sports") {
                const variables: any = {
                    homeTeamId: ticketDetails?.homeTeamId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    eventName: searchEventName ? `%${searchEventName}%` : '%',
                };
                if (ticketDetails?.awayTeamId) {
                    variables.awayTeamId = ticketDetails.awayTeamId;
                }
                getEventsForSingleList({ variables });
            } else {
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: searchEventName ? `%${searchEventName}%` : `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                    }
                })
            }
        }
    }, [page, search, searchEventName, ticketDetails, showAllDates])

    useEffect(() => {

        if (!isFrom) return
        if (!['eventsUpdate', 'eventsOtherLeagues'].includes(isFrom)) return
        const { leagueId, eventName, leagueType } = ticketDetails || {}
        if (!leagueType) return
        if (leagueType.toLowerCase() === "sports") {
                const variables: any = {
                    homeTeamId: ticketDetails?.homeTeamId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    eventName: searchEventName ? `%${searchEventName}%` : '%',
                };
                if (ticketDetails?.awayTeamId) {
                    variables.awayTeamId = ticketDetails.awayTeamId;
                }
                getEventsForSingleList({ variables });
        } else {
            const { leagueId, eventName } = ticketDetails || {}
            if (!leagueId) return
            getEventsForOtherLeagues({
                variables: {
                    eventName: searchEventName ? `%${searchEventName}%` : `%${eventName}%`,
                    leagueId: leagueId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                }
            })
        }
    }, [page, search, searchEventName, ticketDetails, showAllDates]);

    useEffect(() => {
        if (resetEvent) {
            setEvents([])
            setResetEvent && setResetEvent(false)
        }
    }, [resetEvent])

    useEffect(() => {
        if (globalState.eventUpdate.updateEvent) {
            const { leagueId, eventName, leagueType } = ticketDetails || {}
            if (!leagueType) return
            if (page !== 1) return
            if (leagueType.toLowerCase() === "sports") {
                const variables: any = {
                    homeTeamId: ticketDetails?.homeTeamId,
                    limit: rowsPerPage,
                    offset: (currentPage - 1) * rowsPerPage,
                    orderBy: { [columnTypes]: sortType },
                    eventName: searchEventName ? `%${searchEventName}%` : '%',
                };
                if (ticketDetails?.awayTeamId) {
                    variables.awayTeamId = ticketDetails.awayTeamId;
                }
                getEventsForSingleList({ variables });
            } else {
                const { leagueId, eventName } = ticketDetails || {}
                if (!leagueId) return
                getEventsForOtherLeagues({
                    variables: {
                        eventName: searchEventName ? `%${searchEventName}%` : `%${eventName}%`,
                        leagueId: leagueId,
                        limit: rowsPerPage,
                        offset: (currentPage - 1) * rowsPerPage,
                        orderBy: { [columnTypes]: sortType },
                    }
                })
            }
        }

    }, [globalState.eventUpdate.updateEvent, searchEventName]);

    useEffect(() => {

        const { leagueId, eventName, leagueType } = ticketDetails || {}

        if (!leagueType) return

        if (ticketDetails?.isBulkList && leagueType.toLowerCase() === "sports") {
            getEventsForBulkList({
            variables: {
                homeTeamId: ticketDetails?.homeTeamId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
                eventName: searchEventName ? `%${searchEventName}%` : '%',
            }
            })
        }

        else if (leagueType.toLowerCase() === "sports") {
            getEventsForSingleList({
            variables: {
                homeTeamId: ticketDetails?.homeTeamId,
                awayTeamId: ticketDetails?.awayTeamId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
                eventName: searchEventName ? `%${searchEventName}%` : '%',
            }
            })
        }

        else {
            if (!leagueId) return

            getEventsForOtherLeagues({
            variables: {
                eventName: searchEventName ? `%${searchEventName}%` : `%${eventName}%`,
                leagueId,
                limit: rowsPerPage,
                offset: (currentPage - 1) * rowsPerPage,
                orderBy: { [columnTypes]: sortType },
            }
            })
        }

    }, [currentPage, rowsPerPage, sortType, columnTypes, ticketDetails, searchEventName, isFrom]);


    const GenerateEventsHeadCells = () => {
        const id = ["e_name", "e_date", "e_address", "e_date", 'action', 'action']
        const labels = ["Events", "Date", "Venue", "Venue Time", "Period Left", 'Action']
        const headCells = id.map((id, index) => ({
            id,
            label: labels[index],
        }));
        return headCells;
    }

    const handleEventNext = () => {
        if (selectedEvents?.length) {
            setTicketDetails({
                ...ticketDetails,
                eventId: selectedEvents
            });
            setPage(3);
        } else {
            error('Please select any one of the events')
        }

    }

    return (
        <>
            <div style={{ 
                width: '100%', 
                marginBottom: '25px', 
                padding: '20px', 
                backgroundColor: '#fff',
                borderRadius: '12px',
                border: '1px solid #e0e0e0',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
            }}>
                {/* Search Title */}
                <div style={{ marginBottom: '18px' }}>
                    <h3 style={{ margin: '0 0 12px 0', fontSize: '16px', fontWeight: '600', color: '#222' }}>
                        🔍 Search & Filter Events
                    </h3>
                </div>

                {/* Search Input */}
                <div style={{ marginBottom: '18px', display: 'flex', gap: '10px', alignItems: 'flex-end' }}>
                    <TextField
                        fullWidth
                        label="Search Event Name"
                        placeholder="Enter event name, team name, or event type..."
                        value={searchEventName}
                        onChange={handleSearchEventNameChange}
                        size="medium"
                        variant="outlined"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9',
                                '&:hover': {
                                    backgroundColor: '#fff'
                                },
                                '&.Mui-focused': {
                                    backgroundColor: '#fff'
                                }
                            },
                            '& .MuiOutlinedInput-input': {
                                fontSize: '14px'
                            }
                        }}
                    />
                    <Button
                        onClick={handleClearSearch}
                        variant="outlined"
                        size="small"
                        sx={{
                            whiteSpace: 'nowrap',
                            borderColor: '#e0e0e0',
                            color: '#666',
                            '&:hover': {
                                borderColor: '#999',
                                backgroundColor: '#f5f5f5'
                            }
                        }}
                    >
                        Clear
                    </Button>
                </div>

                {/* Checkbox & Results Container */}
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    padding: '12px 0',
                    // borderTop: '1px solid #f0f0f0',
                    borderBottom: '1px solid #f0f0f0'
                }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showAllDates}
                                onChange={handleShowAllDatesChange}
                                sx={{
                                    color: '#1976d2',
                                    '&.Mui-checked': {
                                        color: '#1976d2'
                                    }
                                }}
                            />
                        }
                        label={
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                                📅 Show All Dates (Including TBD)
                            </span>
                        }
                    />
                    {events?.events_aggregate?.aggregate?.count !== undefined && (
                        <div style={{ 
                            fontSize: '14px', 
                            fontWeight: '600', 
                            color: '#1976d2',
                            backgroundColor: '#e3f2fd',
                            padding: '6px 12px',
                            borderRadius: '6px'
                        }}>
                            📊 Total Results: <span style={{ fontSize: '16px' }}>{events?.events_aggregate?.aggregate?.count}</span>
                        </div>
                    )}

                      <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 20,
                width: '100%'
            }}>
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    background: '#f5faff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    padding: '8px 18px',
                    border: '1px solid #e3eaf3',
                }}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleBulkStatusChange(true)}
                        sx={{
                            minWidth: 70,
                            fontWeight: 600,
                            fontSize: '10px',
                            borderRadius: '6px',
                            boxShadow: '0 1px 4px rgba(34,197,94,0.08)',
                            textTransform: 'none',
                            letterSpacing: 0.2
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M9.5 17.5l-5-5 1.41-1.41L9.5 14.67l8.09-8.09L19 7.5l-9.5 10z"/></svg>
                            Activate
                        </span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleBulkStatusChange(false)}
                        sx={{
                            minWidth: 70,
                            fontWeight: 600,
                            fontSize: '10px',
                            borderRadius: '6px',
                            boxShadow: '0 1px 4px rgba(239,68,68,0.08)',
                            textTransform: 'none',
                            letterSpacing: 0.2
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M19 13H5v-2h14v2z"/></svg>
                            Inactivate
                        </span>
                    </Button>
                </div>
            </div>
                </div>
            </div>

            {/* Bulk Action Buttons - Top Right Corner */}
            {/* {selected.length > 0 && events.length > 0 && ( */}
                
            {/* <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 20,
                width: '100%'
            }}>
                <div style={{
                    display: 'flex',
                    gap: '12px',
                    background: '#f5faff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    padding: '8px 18px',
                    border: '1px solid #e3eaf3',
                }}>
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => handleBulkStatusChange(true)}
                        sx={{
                            minWidth: 140,
                            fontWeight: 600,
                            fontSize: '15px',
                            borderRadius: '6px',
                            boxShadow: '0 1px 4px rgba(34,197,94,0.08)',
                            textTransform: 'none',
                            letterSpacing: 0.2
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M9.5 17.5l-5-5 1.41-1.41L9.5 14.67l8.09-8.09L19 7.5l-9.5 10z"/></svg>
                            Activate
                        </span>
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => handleBulkStatusChange(false)}
                        sx={{
                            minWidth: 140,
                            fontWeight: 600,
                            fontSize: '15px',
                            borderRadius: '6px',
                            boxShadow: '0 1px 4px rgba(239,68,68,0.08)',
                            textTransform: 'none',
                            letterSpacing: 0.2
                        }}
                    >
                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M19 13H5v-2h14v2z"/></svg>
                            Inactivate
                        </span>
                    </Button>
                </div>
            </div> */}
            {/* // )} */}

            {

                (bulkListLoading || singleListLoading || otherListLoading) ? <div className={stylesUser.TableCircularProgress}>
                    <CircularProgress color="primary" size={35} />
                </div> :
                
                    <div style={{ width: '100%' }}>
                        <AppTable
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                            handlePageChange={handlePageChange}
                            setColumnTypes={setColumnTypes}
                            sortType={sortType}
                            setSortType={setSortType}
                            setSelected={setSelected}
                            setChecking={setChecking}
                            checking={checking}
                            selected={selected}
                            rowsPerPage={rowsPerPage}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            list={events}
                            // tableTitle={ticketDetails?.isBulkList ? "pickEventsBulkList" : "pickEvents"}
                            tableTitle="pickEventsBulkList"
                            generateHeadCells={GenerateEventsHeadCells}
                          selectedEvents={selectedEvents}
   setSelectedEvents={setSelectedEvents}
                            tablePurpose={isFrom}
                        // handleDropdownChange={handleDropdownChange}
                        // selectedValues={selectedValues}
                        // setSelectedValues={setSelectedValues}
                        />
                        {
                            isFrom === "addTickets" && (events?.events?.length !== 0) && <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <div className={addTicketStyles.eventBtnStyle}>
                                    <Button
                                        classes={{
                                            root: styles.separateStyleReferral
                                        }}
                                        disableRipple
                                        fullWidth
                                        type="button"
                                        onClick={handleEventNext}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
            }
        </>
    )
}

export default PickEvents;
